 <template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="CC" :title="title"></SectionTitle>
    <div class="content-txt">
      <ul class="txt-list clearfix">
        <li class="animate-target" v-animate-in>Review the need for early identification of kidney disease in people with type 2 diabetes</li>
        <li class="animate-target" v-animate-in>Review the current role of albuminuria as a treatment target</li>
        <li class="animate-target" v-animate-in>Understand current guideline-recommended options for heart and kidney risk reduction in people with type 2 diabetes and chronic kidney disease</li>
        <li class="animate-target" v-animate-in>Understand appropriate finerenone use in clinical practice</li>
      </ul>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section2/">Next</GoNext>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s1-6",
  components: {SectionTitle, GoNext},
  data(){
    return {
      title:'Learning objectives'
    }
  }
}
</script>

<style scoped>
  @import "../../assets/css/section1/s1.css";
</style>
